/**
 * LoopStartIcon/index.js
 * desc: loop start step icon
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const LoopStartIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="loop-start icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.loopStart.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.7993 2.6495H18.6747C19.5901 2.6495 20.4219 3.01359 21.0239 3.59952C21.626 4.18558 22 4.99573 22 5.88628V13.7632C22 14.6539 21.6258 15.4636 21.0237 16.0497C20.4216 16.6357 19.5897 17 18.6747 17H3.32527C2.41033 17 1.57807 16.6359 0.97595 16.0499C0.374044 15.4639 0 14.6542 0 13.7632V5.88628C0 4.99511 0.373741 4.18541 0.975821 3.59936C1.5779 3.0133 2.40956 2.6495 3.32527 2.6495H9.28301V0.603372C9.28301 0.27015 9.56055 6.52732e-07 9.90288 6.52732e-07C10.0628 -0.000228601 10.2166 0.0599395 10.3319 0.167845L14.6201 3.4648C14.8875 3.67038 14.9329 4.04814 14.7217 4.30842C14.6892 4.3486 14.6515 4.38457 14.6096 4.41545L10.2854 7.7401C10.018 7.94563 9.6299 7.90138 9.41871 7.64114C9.33253 7.53519 9.28574 7.40395 9.28598 7.26881H9.28301V5.06307H3.32527C3.09384 5.06307 2.88251 5.15609 2.72882 5.3057C2.57512 5.45531 2.47956 5.66113 2.47956 5.88628V13.7632C2.47956 13.9882 2.57529 14.1939 2.72895 14.3435C2.88282 14.4932 3.09426 14.5864 3.32527 14.5864H18.6747C18.9054 14.5864 19.1169 14.4931 19.2707 14.3433C19.4245 14.1936 19.5204 13.9879 19.5204 13.7632V5.88628C19.5204 5.66142 19.4247 5.4556 19.2709 5.30587C19.1172 5.15626 18.9059 5.06307 18.6747 5.06307H17.7993V2.6495Z"/>
        </svg>
    </IconButton>
);


export default LoopStartIcon;
